import { Box, Modal } from "@mui/material";
import React from "react";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./TokenPayment.module.css";
import { useEffect } from "react";
import CustomInput from "../../Subcomponents/CustomInput";
import { useState } from "react";
import Button from "../../Subcomponents/Button";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";

const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const TokenPayment = ({ open, handleClose, tokenDetails, tokenPaymentResponse, payableTokenData, handleOpenPaymentGatewaySelectionModal }) => {
	const [payableAmount, setPayableAmount] = useState(0);
	const [enableBtn, setEnableBtn] = useState(false);
	const [helperText, setHelperText] = useState("");
	const classes = useStyles();
	useEffect(() => {
		let amt =
			payableTokenData !== null
				? payableTokenData?.tokenId?.amount > 500000
					? 500000
					: payableTokenData?.tokenId?.amount
				: tokenDetails?.amount - tokenDetails.paidAmount > 500000
				? 500000
				: tokenDetails?.amount - tokenDetails.paidAmount;
		console.log(amt, payableTokenData);
		setPayableAmount(amt);
		setEnableBtn(true);
	}, []);
	function closeModal() {
		handleClose();
	}

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Token Payment</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.priceBreakDown}>
						<div className={cssClasses.price}>
							<span>Token Amount : </span>
							<span>₹ {numberWithCommas(tokenDetails?.amount)}</span>
						</div>
						<div className={cssClasses.paidAmt}>
							<span>Paid Amount: </span>
							<span>₹ {numberWithCommas(tokenDetails.paidAmount)}</span>
						</div>
						<div className={cssClasses.price}>
							<span>Amount Due : </span>
							<span>
								₹{" "}
								{numberWithCommas(
									payableTokenData !== null ? payableTokenData?.tokenId?.amount : tokenDetails.amount - tokenDetails.paidAmount
								)}
							</span>
						</div>
					</div>
					<div className={cssClasses.amountInputWrap}>
						<CustomInput
							value={payableAmount}
							label={"Enter amount"}
							mandatory={true}
							inputType={"number"}
							position="start"
							labelText={RupeeIcon}
							image={"true"}
							disabled={tokenDetails?.eventTokenId?.tokenId?.isPriorityPass || tokenDetails?.eventTokenId?.tokenId?.paymentType}
							handleChange={(amt) => {
								setEnableBtn(false);
								amt = amt === "" ? "0" : amt;
								var numbers = /^[0-9]+$/;
								setPayableAmount(parseInt(amt));
								if (
									amt.match(numbers) &&
									parseInt(amt) >= 0 &&
									parseInt(amt) <=
										(payableTokenData !== null
											? payableTokenData?.tokenId?.amount > 500000
												? 500000
												: payableTokenData?.tokenId?.amount
											: tokenDetails?.amount - tokenDetails?.paidAmount > 500000
											? 500000
											: tokenDetails?.amount - tokenDetails?.paidAmount)
								) {
									if (parseInt(amt) > 0) setEnableBtn(true);
								} else {
									setEnableBtn(false);
								}
								if (payableTokenData !== null && parseInt(amt) > payableTokenData?.tokenId?.amount) {
									setHelperText(
										`Max. amount to be paid: ₹ ${numberWithCommas(
											payableTokenData?.tokenId?.amount > 500000 ? 500000 : payableTokenData?.tokenId?.amount
										)}`
									);
								} else if (payableTokenData === null && parseInt(amt) > tokenDetails?.amount - tokenDetails.paidAmount) {
									setHelperText(
										`Max. amount to be paid: ₹ ${numberWithCommas(
											tokenDetails?.amount - tokenDetails.paidAmount > 500000
												? 500000
												: tokenDetails?.amount - tokenDetails.paidAmount
										)}`
									);
								} else if (parseInt(amt) > 500000) {
									setHelperText("Payable Amount limit is 500000");
								} else {
									setHelperText("");
								}
							}}
							helperText={helperText}
						/>
						<p style={{ fontStyle: "italic", color: "#667085" }}>
							Max. amount to be paid: ₹{" "}
							{numberWithCommas(
								payableTokenData !== null
									? payableTokenData?.tokenId?.amount > 500000
										? 500000
										: payableTokenData?.tokenId?.amount
									: tokenDetails?.amount - tokenDetails.paidAmount > 500000
									? 500000
									: tokenDetails?.amount - tokenDetails.paidAmount
							)}
						</p>
					</div>
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#344054",
								backgroundColor: "#ffffff",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Cancel"}
							clicked={() => {
								closeModal();
							}}
						/>
					</div>
					<div>
						<Button
							style={{
								color: "#ffffff",
								backgroundColor: "#155EEF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							disable={!enableBtn}
							btnName={"Pay Now11"}
							clicked={() => {
								handleOpenPaymentGatewaySelectionModal(payableAmount);
								// tokenPaymentResponse(payableAmount);
							}}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default TokenPayment;
